// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:d7426ca7-2547-40c1-83e9-7352f09272f6",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_R83nmh3dG",
    "aws_user_pools_web_client_id": "2a7ppjc198qgrfpgs4th095s1v",
    "oauth": {}
};


export default awsmobile;
